module.exports = {

  // Status = { OK (0), NOTAUTHED (1), REJECTED (2), THREEDAUTH (3), MALFORMED (4), INVALID (5), ERROR (6), ERROREXTENDED (7), AUTHENTICATED (8), REGISTERED (9) }
  Statuses:
    [
      { Id: 0, Name: 'OK' }, { Id: 1, Name: 'NOTAUTHED' }, { Id: 2, Name: 'REJECTED' }, { Id: 3, Name: 'THREEDAUTH' }, { Id: 4, Name: 'MALFORMED' },
      { Id: 5, Name: 'INVALID' }, { Id: 6, Name: 'ERROR' }, { Id: 7, Name: 'ERROREXTENDED' }, { Id: 8, Name: 'AUTHENTICATED' }, { Id: 9, Name: 'REGISTERED' },
    ],

  Responses:
    [
      {
        PassRequired: false,
        For: ['OK', 'AUTHENTICATED', 'REGISTERED'],
        Messages:
          [
            {
              BookingType: 'villa', PaymentType: 'balance', Success: true, Heading: 'Many thanks for making your balance payment!', Description: 'Your holiday is on the horizon and you’ll be heading to the airport before you know it. Have you got everything planned? If not, we recommend you call on the invaluable assistance of your dedicated Experience Specialist. Whether you need to rent a car, order some wine, or book a luxury boat charter, they’re here to make your life easy. They’re also experts in logistics and they’d be delighted to help you with rooming arrangements, check-in times, and all those other little details that you may not have had time to think about yet. Email experiences@thethinkingtraveller.com or call ##phonenumber## <br/> While they’re doing all the hard work, why not whet your holiday appetite by reading out our in-depth guides, downloading our destination Spotify playlists, and following us on Instagram?',
            },
            {
              BookingType: 'villa', PaymentType: 'deposit', Success: true, Heading: 'Congratulations on your booking!', Description: 'Your deposit payment has been received. Many thanks for booking with us. <br/> What’s next? Well, it’s never too early to start planning the finer details of your holiday, and one of our dedicated Experience Specialists will be in touch in good time to assist you with this. If you’d like to contact them sooner, please feel free to do so by emailing experiences@thethinkingtraveller.com. Their role is to make your holiday a logistical breeze, and they’ll be on hand to arrange any of our stress-busting extra services (airport transfers and in-villa car hire delivery*, in-villa wine and hamper deliveries, in-villa cooks, and much more), or Experiences (a unique range of thrilling adventures, cultural enrichments and gastronomic inspirations designed to transform a great holiday into a life-enhancing one). <br/> In the meantime, why not get into the holiday mood by checking out our destination guides, listening to our dedicated Spotify playlists, and following us on Instagram?',
            },
            {
              BookingType: 'service', PaymentType: null, Success: true, Heading: 'Thank you for your booking!', Description: 'Your payment has gone through successfully. Should you wish to book any other extra services or Experiences for your holiday, please don’t hesitate to contact your Experience Specialist, {0}.',
            },
            {
              BookingType: 'service', PaymentType: 'balance', Success: true, Heading: 'Thank you for your booking!', Description: 'Your payment has gone through successfully. Should you wish to book any other extra services or Experiences for your holiday, please don’t hesitate to contact your Experience Specialist, {0}.',
            },
            {
              BookingType: 'service', PaymentType: 'deposit', Success: true, Heading: 'Thank you for your booking!', Description: 'Your payment has gone through successfully. Should you wish to book any other extra services or Experiences for your holiday, please don’t hesitate to contact your Experience Specialist, {0}.',
            },
            {
              BookingType: 'wine', PaymentType: null, Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. Your wine will be delivered to your villa for your arrival.',
            },
            {
              BookingType: 'wine', PaymentType: 'balance', Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. Your wine will be delivered to your villa for your arrival.',
            },
            {
              BookingType: 'wine', PaymentType: 'deposit', Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. Your wine will be delivered to your villa for your arrival. ',
            },
          ],
      },

      {
        PassRequired: true,
        For: ['OK', 'AUTHENTICATED', 'REGISTERED'],
        Messages:
          [
            {
              BookingType: 'villa', PaymentType: 'balance', Success: true, Heading: 'Congratulations!', Description: 'Your balance has been received. To proceed to your account and view your booking, please enter your desired password below.',
            },
            {
              BookingType: 'villa', PaymentType: 'deposit', Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. To proceed to your account and view your booking, please enter your desired password below.',
            },
            {
              BookingType: 'service', PaymentType: null, Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. To proceed to your account and view your booking, please enter your desired password below.',
            },
            {
              BookingType: 'service', PaymentType: 'balance', Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. To proceed to your account and view your booking, please enter your desired password below.',
            },
            {
              BookingType: 'service', PaymentType: 'deposit', Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. To proceed to your account and view your booking, please enter your desired password below.',
            },
            {
              BookingType: 'wine', PaymentType: null, Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. To proceed to your account and view your booking, please enter your desired password below.',
            },
            {
              BookingType: 'wine', PaymentType: 'balance', Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. To proceed to your account and view your booking, please enter your desired password below.',
            },
            {
              BookingType: 'wine', PaymentType: 'deposit', Success: true, Heading: 'Thank you!', Description: 'Your payment has been received. To proceed to your account and view your booking, please enter your desired password below.',
            },
          ],
      },

      {
        PassRequired: null,
        For: ['ERROR'],
        Messages:
          [
            {
              BookingType: null, PaymentType: null, Success: false, Heading: 'Payment failed', Description: 'We are sorry, there appears to be a problem with our payment system. Your provisional booking is still on hold and your card has not been charged.Please try again a bit later.<br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##',
            },
          ],
      },

      {
        PassRequired: null,
        For: ['ERROR_AFTER_PAYMENT'],
        Messages:
          [
            {
              BookingType: null, PaymentType: null, Success: false, Heading: 'Confirmation check', Description: 'We are sorry but there seems to have been an error processing the details of your booking. We have securely received your payment, but confirmation needs to be checked by one of our Villa Specialists before the process can be complete. If you would like to speak to one of our team now please call: ##phonenumber##. Otherwise we will be in contact with you shortly.',
            },
          ],
      },

      {
        PassRequired: null,
        For: ['NOTAUTHED'],
        Messages:
          [
            {
              BookingType: null, PaymentType: null, Success: false, Heading: 'Payment failed', Description: 'We were unable to process your payment correctly. Authorisation was declined by your bank. <br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##',
            },
          ],
      },

      {
        PassRequired: null,
        For: ['MALFORMED', 'INVALID'],
        Messages:
          [
            {
              BookingType: null, PaymentType: null, Success: false, Heading: 'Payment failed', Description: "We were unable to process your payment correctly. Your provisional option is still in place, and your card has not been charged. We think everything is working at our end. Are you sure you've entered your payment details correctly?<br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##",
            },
          ],
      },

      {
        PassRequired: null,
        For: ['REJECTED'],
        Messages:
          [
            {
              BookingType: null, PaymentType: null, Success: false, Heading: 'Payment failed', Description: 'There has been a problem with the authorisation process. Please can you check that the billing address, post code and security code are all correct, or try a different card?<br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##',
            },
          ],
      },

      {
        PassRequired: null,
        For: ['REJECTED_3dwrongcode'],
        Messages:
          [
            {
              BookingType: null, PaymentType: null, Success: false, Heading: 'Payment failed', Description: '3D-Secure authentication failed.<br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##',
            },
          ],
      },

      {
        PassRequired: null,
        For: ['REJECTED_3dnotenrolled'],
        Messages:
          [
            {
              BookingType: null, PaymentType: null, Success: false, Heading: 'Payment failed', Description: '3D-Secure authentication failed. The card or card issuer is not part of the 3D-Secure scheme. <br/> If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##',
            },
          ],
      },

      {
        PassRequired: null,
        For: ['ERROREXTENDED'],
        Messages:
          [
            {
              BookingType: null, PaymentType: null, Success: false, Heading: 'Payment failed', Description: 'We are sorry, there appears to be a problem with our payment system. Your provisional booking is still on hold and your card has not been charged.Please try again a bit later.<br/> <br/>If you are experiencing difficulties and would prefer to speak to one of our team please call: ##phonenumber##',
            },
          ],
      },

    ],
};
